var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_0_11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6654 7.99967H13.012C12.7207 7.99905 12.4371 8.09388 12.2048 8.26965C11.9724 8.44543 11.804 8.69247 11.7254 8.97301L10.1587 14.5463C10.1486 14.581 10.1275 14.6114 10.0987 14.633C10.0698 14.6546 10.0348 14.6663 9.9987 14.6663C9.96264 14.6663 9.92755 14.6546 9.8987 14.633C9.86985 14.6114 9.8488 14.581 9.8387 14.5463L6.1587 1.45301C6.1486 1.41839 6.12755 1.38798 6.0987 1.36634C6.06985 1.3447 6.03476 1.33301 5.9987 1.33301C5.96264 1.33301 5.92755 1.3447 5.8987 1.36634C5.86985 1.38798 5.8488 1.41839 5.8387 1.45301L4.27203 7.02634C4.19367 7.30578 4.02629 7.55202 3.79527 7.72768C3.56426 7.90335 3.28224 7.99884 2.99203 7.99967H1.33203",
    stroke: "var(--stroke-0, #5B646F)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpActivity);
export default __webpack_public_path__ + "static/media/op-activity.9b4791f40aac6453f81093d187f49f44.svg";
export { ForwardRef as ReactComponent };